import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class RoadmapTableInitiativeWaitingForAnswersController extends Controller {
  @service store;

  get openWfas() {
    return this.store
      .peekAll('wfa')
      .filter(
        (item) =>
          item?.initiative.get('id') === this.model.initiative.id &&
          !item.completed,
      );
  }

  get closedWfas() {
    return this.store
      .peekAll('wfa')
      .filter(
        (item) =>
          item?.initiative.get('id') === this.model.initiative.id &&
          item.completed === true,
      );
  }

  @action
  addNewWfa() {
    const newButton = document.querySelector('.new-wfa-button');
    if (newButton) newButton.click();
  }
}
